import React from 'react';
import { renderToString } from 'react-dom/server';
import { useDispatch, useSelector } from 'react-redux';
import QRImage from 'react-qr-image';

import { formatDate } from 'utilities/common';
import { Shipment } from 'services/action';

import { Print } from 'ui/components';
import logoBlack from 'ui/assets/envio-black.png';

const POD_URL = `${process.env.REACT_APP_POD_SYSTEM_URL}`;

const PrintShipment = ({ match }) => {
  const Dispatch = useDispatch();
  const client = useSelector((state) => state?.Auth?.session?.client);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const [data, setData] = React.useState(null);

  const $onLoad = async (id) => {
    const detail = await Dispatch(Shipment.$show(id, { load_shipment: true }));
    if (detail?.message === 'success') {
      setData(detail?.data?.shipment);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match]);

  console.log(client);

  if (StateLoading && !data) return null;

  return (
    <div>
      {!data || data === null ? null : (
        <Print
          title={`Shipment - ${data?.code}`}
          size="A5 landscape"
          content={renderToString(
            <section className=" sheet page-break" style={{ padding: '20px' }}>
              <div
                className="d-flex flex-row justify-content-between"
                style={{ height: 132 }}
              >
                <div className="" style={{ width: '85%' }}>
                  <div
                    className="d-flex align-items-center border-bottom"
                    style={{
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                  >
                    <div style={{ alignSelf: 'initial', width: '30%' }}>
                      <img
                        src={client?.avatar?.replace('_thumb', '') || logoBlack}
                        alt=""
                        style={{ maxHeight: 50, maxWidth: '100%' }}
                      />
                    </div>
                    <div style={{ paddingLeft: 20 }}>
                      <h2 className="bold uppercase">Shipment</h2>
                      <p className="mb-0">
                        Tanggal Pengiriman :{' '}
                        {formatDate(data?.etd_at, 'DD-MM-YYYY')}
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{ width: '15%' }}>
                  <div className="d-flex flex-column justify-content-center text-center align-items-center">
                    <QRImage
                      text={`${POD_URL}/shipment/${data?.id}`}
                      color="#000"
                      background="#fff"
                      style={{ height: 120 }}
                    />
                    <p className="mb-0" style={{ fontSize: 9 }}>
                      {data?.code}
                    </p>
                    <p style={{ fontSize: 8 }}>REF: {data?.ref_code}</p>
                  </div>
                </div>
              </div>

              <table className="body" style={{ marginTop: -50 }}>
                <tr style={{ verticalAlign: 'top' }}>
                  <td style={{ width: '50%', paddingTop: '10px' }}>
                    <div style={{ marginBottom: '15px' }}>
                      <h5 className="bold uppercase">Shipper :</h5>
                      <p className="mb-0">
                        {data?.shipper?.name} - {data?.shipper?.phone}
                      </p>
                      <p className="mb-0">{data?.origin?.address}</p>
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                      <h5 className="bold uppercase">Penerima / Recipient :</h5>
                      {data?.destination?.name ===
                      data?.destination?.contact_person ? (
                        <p className="mb-0">
                          {data?.destination?.contact_person} -{' '}
                          {data?.destination?.phone_number}
                        </p>
                      ) : (
                        <>
                          <p className="mb-0">{data?.destination?.name}</p>
                          <p className="mb-0">
                            {data?.destination?.contact_person} -{' '}
                            {data?.destination?.phone_number}
                          </p>
                        </>
                      )}

                      <p className="mb-0">{data?.destination?.address}</p>
                      <p className="bold mb-0">
                        {data?.destination?.region?.district_name},{' '}
                        {data?.destination?.region?.regency_name},{' '}
                        {data?.destination?.region?.province_name}
                      </p>
                      {data?.destination?.wrt ? (
                        <p className="mb-0">
                          Waktu Penerimaan {data?.destination?.wrt}
                        </p>
                      ) : null}
                    </div>
                  </td>
                  <td style={{ width: '50%', paddingTop: '10px' }}>
                    <div style={{ marginTop: 55 }}>
                      <table className="bordered">
                        <thead>
                          <tr className="bordered">
                            <td
                              className="bordered left"
                              style={{ width: '30%' }}
                            >
                              <p className="bold mb-0">Barang</p>
                            </td>
                            <td
                              className="bordered center"
                              style={{ width: '10%' }}
                            >
                              <p className="bold mb-0">Koli</p>
                            </td>
                            <td
                              className="bordered right"
                              style={{ width: '30%' }}
                            >
                              <p className="bold mb-0">Total Berat (Kg)</p>
                            </td>
                            <td
                              className="bordered right"
                              style={{ width: '30%' }}
                            >
                              <p className="bold mb-0">Volumetrik (Kg)</p>
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.items?.map((j, i) => (
                            <tr
                              className="bordered"
                              key={i}
                              style={{
                                height:
                                  client?.id ===
                                    'ffeffe0c-d7a3-43f6-9996-88b7efa557db' &&
                                  40,
                              }}
                            >
                              <td className="bordered left">
                                <p className=" mb-0">{j?.item_name}</p>
                              </td>
                              <td className="bordered center">
                                <p className=" mb-0">
                                  {client?.id ===
                                  'ffeffe0c-d7a3-43f6-9996-88b7efa557db'
                                    ? ''
                                    : j?.quantity}
                                </p>
                              </td>
                              <td className="bordered right">
                                <p className=" mb-0">
                                  {client?.id ===
                                  'ffeffe0c-d7a3-43f6-9996-88b7efa557db'
                                    ? ''
                                    : j?.weight}
                                </p>
                              </td>
                              <td className="bordered right">
                                <p className=" mb-0">
                                  {client?.id ===
                                  'ffeffe0c-d7a3-43f6-9996-88b7efa557db'
                                    ? ''
                                    : j?.m3}
                                </p>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </table>

              <table className="body bordered" style={{ marginTop: 20 }}>
                <tr className="bordered">
                  <td className="bordered" style={{ width: '33%' }}>
                    <p className="bold mb-0">Shipper</p>
                  </td>
                  <td className="bordered" style={{ width: '33%' }}>
                    <p className="bold mb-0">Driver</p>
                  </td>
                  <td className="bordered" style={{ width: '33%' }}>
                    <p className="bold mb-0">Penerima / Recipient</p>
                  </td>
                </tr>
                <tr className="bordered">
                  <td
                    className="bordered"
                    style={{ width: '33%', height: 80 }}
                  ></td>
                  <td
                    className="bordered"
                    style={{ width: '33%', height: 80 }}
                  ></td>
                  <td
                    className="bordered"
                    style={{ width: '33%', height: 80, padding: 0 }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        alignItems: 'stretch',
                        textAlign: 'center',
                      }}
                    >
                      <p
                        className="bold"
                        style={{ marginBottom: 60, fontSize: 8 }}
                      >
                        Diterima dalam kondisi yang baik dan cukup
                      </p>
                      <p className="mb-0 bold" style={{ fontSize: 8 }}>
                        Nama / TTD / Stemple
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bordered">
                  <td className="bordered" style={{ width: '33%' }}>
                    <p className="bold mb-0">Tanggal :</p>
                  </td>
                  <td className="bordered" style={{ width: '33%' }}>
                    <p className="bold mb-0">Tanggal :</p>
                  </td>
                  <td className="bordered" style={{ width: '33%' }}>
                    <p className="bold mb-0">Tanggal :</p>
                  </td>
                </tr>
              </table>
            </section>
          )}
        />
      )}
    </div>
  );
};

export default PrintShipment;
